const workoutlistComponent = {
    init: (container) => {
        var workoutListContainer = container.querySelector("[data-trainingcards]");
        var workoutlist = container.querySelector("[data-workoutlistslider]");
        const slides = container.querySelectorAll('.slider');
        const progressBarContainer = container.querySelector('[data-scrollbartrack]');
        const prevButton = container.querySelector('[data-prevButton]');
        const nextButton = container.querySelector('[data-nextButton]');
        const totalItems = slides.length;
        const itemWidth = workoutlist.querySelector('.slider').clientWidth;
        let currentSlide = 0;
        let isUserScrolling = true;
        let startX = 0;
        let translateStart = 0;
        let isDragging = false;

        const getItemsPerSlide = () => {
            const carouselWidth = workoutListContainer.clientWidth;
            const itemWidth = slides[0].clientWidth;
            return Math.floor(carouselWidth / itemWidth);
        };

        const innerWitdthCheck = () => {
            return window.innerWidth >= 768
        }

      
        let itemsPerSlide = getItemsPerSlide() > 4 ? 4 : getItemsPerSlide();

        let lastItemGap = getMultipler = () => innerWitdthCheck() ? 42 : 24

        const updateButtons = () => {
            prevButton.disabled = currentSlide === 0;

            if (totalItems == 4 && innerWitdthCheck()) {
                    nextButton.disabled = currentSlide >= totalItems - (itemsPerSlide - 1);
                } else nextButton.disabled = currentSlide >= totalItems - itemsPerSlide;

            if (totalItems == 4 && innerWitdthCheck()) {
                nextButton.classList.toggle('disabled', currentSlide >= totalItems - (itemsPerSlide - 1));
            } else nextButton.classList.toggle('disabled', currentSlide >= totalItems - itemsPerSlide);

            prevButton.classList.toggle('disabled', currentSlide === 0);
           
        };

        const goToNextSlide = () => {
            isUserScrolling = false;
            if (!nextButton.disabled) {
                currentSlide++;
                updateCarouselPosition();
                updateButtons();
                updateValues();
                setTimeout(() => isUserScrolling = true, 300);
            }
        };

        const goToPrevSlide = () => {
            isUserScrolling = false;
            if (currentSlide > 0) {
                currentSlide--;
                updateCarouselPosition();
                updateButtons();
                updateValues();
                setTimeout(() => isUserScrolling = true, 300);
            }
        };

        const calculateTranslateValue = () => {
            return currentSlide * itemWidth;
        };

        const getSpacingOffset = () => {
            const translateValue = calculateTranslateValue();
            return currentSlide === 0
                ? 0
                : (currentSlide + itemsPerSlide) === totalItems
                    ? (currentSlide * lastItemGap) + translateValue
                    : (currentSlide * 24) + translateValue;
        }

        const updateCarouselPosition = () => {
            let spacingOffset = getSpacingOffset();

            // Calculates the maximum scrollable width:
            // (Total number of items in the list)
            // Minus (-)
            // (Number of visible cards per slide `itemsPerSlide`)
            // Multiplied by (*)
            // The width including the gap per card (326px)
            // Plus (+)
            // Additional side paddings and hover scaling (90px isch total)
            //
            // Note: This is disabled when only 1 card is visible.
            const maxTranslateX = (totalItems - itemsPerSlide) * 326 + 90;
            if (spacingOffset > maxTranslateX || currentSlide >= totalItems - itemsPerSlide && itemsPerSlide > 1 && currentSlide !== 0) {
                spacingOffset = maxTranslateX;
            }

            workoutlist.style.transform = `translateX(-${spacingOffset}px)`;
        };

        const updateProgressOnScroll = () => {
            if (!isUserScrolling) return;
            const translateX = getTranslateX(workoutlist);
            currentSlide = Math.round(translateX / itemWidth);
            updateButtons();
            updateValues();
        };

        const getTranslateX = (element) => {
            const style = window.getComputedStyle(element);
            const matrix = new DOMMatrixReadOnly(style.transform);

            // Get translateX() value --
            return Math.abs(matrix.m41);
        };

        const updateValues = () => {
            progressBarContainer.setAttribute('min', itemsPerSlide < totalItems ? (itemsPerSlide).toString() : totalItems.toString());
            progressBarContainer.setAttribute('max', totalItems.toString());
            progressBarContainer.setAttribute('value', totalItems == 4 && innerWitdthCheck() ? "4" : itemsPerSlide < totalItems ? (currentSlide + itemsPerSlide).toString() : totalItems.toString());
        };

        const handleResize = () => {
            itemsPerSlide = getItemsPerSlide();
            updateButtons();
            updateCarouselPosition();
            updateValues();
            lastItemGap = getMultipler();
        };

        const debouncedHandleResize = site.helpers.debounce(handleResize, 300);
        window.addEventListener('resize', debouncedHandleResize);

        nextButton.addEventListener('click', goToNextSlide);
        prevButton.addEventListener('click', goToPrevSlide);
        workoutlist.addEventListener('scroll', updateProgressOnScroll, { passive: true });

        workoutlist.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowRight') {
                event.preventDefault();
                goToNextSlide();
            } else if (event.key === 'ArrowLeft') {
                event.preventDefault();
                goToPrevSlide();
            }
        });

        const enableTouchScrollSnap = () => {
            workoutlist.addEventListener("touchstart", (event) => {
                isDragging = true;
                startX = event.touches[0].clientX;
                translateStart = getTranslateX(workoutlist);
                // Disable transition while dragging --
                workoutlist.style.transition = "none";
            });

            workoutlist.addEventListener("touchmove", (event) => {
                event.preventDefault();
                if (!isDragging) return;

                const touchDelta = event.touches[0].clientX - startX;
                const newTranslateX = translateStart - touchDelta;
                workoutlist.style.transform = `translateX(-${newTranslateX}px)`;
            });

            workoutlist.addEventListener("touchend", () => {
                isDragging = false;

                // Re-enable transition --
                workoutlist.style.transition = "transform 0.3s ease";
                snapToNearestSlide();
            });

            workoutlist.addEventListener("scroll", updateProgressOnScroll, { passive: true });
        };

        const snapToNearestSlide = () => {
            const itemWidth = workoutlist.querySelector('.slider').clientWidth;
            const translateX = getTranslateX(workoutlist);

            const screenGap = 185;

            // Determine max scroll position (prevent scrolling beyond last item)
            const maxTranslateX = ((totalItems - itemsPerSlide) * itemWidth) + screenGap;
            
            // Determine scroll direction
            const direction = translateX > currentSlide * itemWidth ? 1 : -1;

            // Calculate next slide considering direction
            if (direction === 1) {
                currentSlide = Math.min(Math.round(translateX / itemWidth), totalItems - itemsPerSlide);
            } else {
                currentSlide = Math.max(Math.floor(translateX / itemWidth), 0);
            }

            let spacingOffset = getSpacingOffset();

            // Ensure we don't overscroll past the last item
            if (spacingOffset > maxTranslateX) {
                spacingOffset = maxTranslateX;
            }

            // Smoothly snap to the correct position
            workoutlist.style.transform = `translateX(-${spacingOffset}px)`;

            updateButtons();
            updateValues();
        };

        enableTouchScrollSnap();
        handleResize(); // Initial setup
    }
};

document.addEventListener('DOMContentLoaded', () => {
    const workoutlists = document.querySelectorAll('[data-workoutlistcontainer]');
    if (workoutlists && workoutlists.length > 0) {
        workoutlists.forEach((item) => {
            workoutlistComponent.init(item);
        });
    }
});
